import { Information } from '../../../Information'
import type { CompanySurvey_questions } from '../../types/CompanySurvey'
import { EmptyTextValue } from '../EmptyTextValue'

interface Props {
  question: CompanySurvey_questions
}

export const Text = ({ question }: Props) => {
  const textValue = question.answer?.textValue || ''

  return (
    <>
      <Information.InformationField label={question.title}>
        {textValue || <EmptyTextValue />}
      </Information.InformationField>
    </>
  )
}
